import {
  HTTP_DELETESPECIAL_FETCHING,
  HTTP_DELETESPECIAL_SUCCESS,
  HTTP_DELETESPECIAL_FAILED,
  server,
  OK,
  YES,
} from "./../../Constants";
import { httpClient } from "./../../utils/HttpClient";
import { async } from "q";
import Axios from "axios";

//Update Special
export const setStatedeleteSpecialToFetching = () => ({
  type: HTTP_DELETESPECIAL_FETCHING,
});

export const setStatedeleteSpecialToSuccess = (payload) => ({
  type: HTTP_DELETESPECIAL_SUCCESS,
  payload,
});

export const setStatedeleteSpecialToFailed = (payload) => ({
  type: HTTP_DELETESPECIAL_FAILED,
});

export const deleteBudgetOById = (item) => {
  return async (dispatch) => {
    dispatch(setStatedeleteSpecialToFetching());
    try {
      // const result = await httpClient.put(
      await Axios.post(`${server.DELETESPECIAL_URL}`, item, {
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      dispatch(setStatedeleteSpecialToSuccess("success"));
    } catch (error) {
      dispatch(setStatedeleteSpecialToFailed());
    }
  };
};
